export default {
  // 品牌管理
  brand_list_edit: 'brand_list_edit',
  //   业务员
  agent_list_edit: 'agent_list_edit',
  agent_list_add: 'agent_list_add',
  agent_list_del: 'agent_list_del',
  agent_list_qrcode: 'agent_list_qrcode',
  agent_list_qrcode_status: 'agent_list_qrcode_status',
  agent_list_qrcode_download: 'agent_list_qrcode_download',
  //   商户
  merchant_list_detail: 'merchant_list_detail',
  merchant_list_del: 'merchant_list_del',
  merchant_list_del_mult: 'merchant_list_del_mult',
  // 收货地址管理
  address_list_export: 'address_list_export',
  address_list_del: 'address_list_del',
  address_list_del_mult: 'address_list_del_mult',
  // 管理员
  user_add: 'user_add', // 添加
  user_edit: 'user_edit', // 编辑
  user_del: 'user_del', // 删除

  // 角色管理
  role_add: 'role_add',
  role_edit: 'role_edit',
  role_auth_menu: 'role_auth_menu',
  role_del: 'role_del',

  // 菜单管理
  menu_add: 'menu_add',
  menu_edit: 'menu_edit',
  menu_del: 'menu_del',
  //   系统设置-站点
  site_edit: 'site_edit',
  //   系统设置-协议
  agree_edit: 'agree_edit',
  // 支付宝
  // 产品列表
  product_list_add: 'product_list_add',
  product_list_edit: 'product_list_edit',
  product_list_del: 'product_list_del',
  // 申请列表
  ali_apply_list_del: 'ali_apply_list_del',
  // 配置页面
  ali_config_list_submit: 'ali_config_list_submit'
}
